import React from "react";
import {Link} from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import '../style/home.css';
import axios from "axios";
import Swal from "sweetalert2";


class Gali extends React.Component {

    constructor() {


        super();
        this.state = {
            single: "-",
            double: "-",
            wallet: "0",
            results:[],
            width_b:"0%",
            width:"0%",
            nav_display:"none",
            transfer_point:"none",
        }


    }

    componentDidMount() {


        var form = new FormData();
        form.append("session", localStorage.getItem("token"));
        form.append("mobile", localStorage.getItem("mobile"));

        axios
            .post(process.env.REACT_APP_URL+"/api2/delhi_markets.php", form,
            )
            .then((response) => {
                if(response.status === 200){
                    if (response.data.nosession){
                        Swal.fire({
                            toast: true,
                            title: 'Oops...',
                            text: "Session Expired"
                        }).then((e)=>{
                            localStorage.clear()
                            window.location.href = "/login";
                        })
                    }
                    let transfer;
                    if (response.data.transfer_points_status === "1"){
                        transfer = "flex";
                    } else {
                        transfer = "none";
                    }
                    this.setState({
                        transfer_point: transfer,
                        results:response.data.data,
                        single:response.data.single,
                        double:response.data.jodi
                    })
                } else if(response.status === 401){
                    //  navigate("/login")
                }
            })
    }


    render() {

        let marketCloseError = ()=>{
            Swal.fire({
                toast: true,
                title: 'Oops...',
                text: "Market Already Closed, Please come again tomorrow"
            })
        }

        return (<>
                <div className="RootView" style={{background:"#eee"}}>
                    <div className="RootWidth">

                        <div className="loginDiv" >


                            <div className="toolbar">
                                <div>
                                    <img onClick={()=>{window.history.go(-1)}}  src="../images/back.png" style={{padding: "5px"}}/>
                                    <span>Gali Desawar</span>
                                </div>


                            </div>



                            <div style={{padding:"5px"}}>

                            <div className="gameRateBox">
                                <p className="mainTitle">Game Rate</p>
                                <div className="grid2x2">
                                <div className="delhi_rate_block">
                                    <p  className="delhi_rate">Single <span>{this.state.single}</span></p>
                                </div>
                                <div className="delhi_rate_block">
                                    <p  className="delhi_rate">Jodi <span>{this.state.double}</span></p>
                                </div>
                              
                            </div>
                            </div>


                            

                              
                           

<div className="grid2x2">
                                {this.state.results &&

                                    this.state.results.map((result) => {
                                        let marketStatus = ""
                                        if(result.is_close === "0") { marketStatus = "Market Closed" } else { marketStatus = "Market Open" }
                                        return (

                                <div className="market_box gali_box" key={result.market}>
                                   
                                    <div className="main">
                                       
                                        <div style={{display:"flex", justifyContent:"space-between"}}>
                                            <div className="inner_market_box" style={{textAlign:"center"}}>
                                            <span className="market_name">{result.market}</span>
                                                <span className="market_name">{result.time}</span>
                                                
                                                <span className="market_result"  style={{color:"white"}}>{result.result}</span>
                                                {result.is_open === "1" ?
                                                    <span className="gali_msg" style={{color:"green"}}>Running Now</span>
                                                    :
                                                    <span className="gali_msg" style={{color:"red"}}>Closed for Today</span>
                                                }
                                            </div>
                                            <img style={{height:"49px", margin:"5px"}} src="../images/clock_big.png" />
                                        </div>
                                        <div className="" >
                                            { result.is_open === "1" ?
                                                <Link to={'/galiGames'} state={[{market: result.market, is_open: "1"}]}>
                                              <div className="gali_active">
                                                    <img src="../images/play_button2.png" />
                                                    <span style={{fontWeight:"500"}}>Play Now</span>

                                              </div>
                                          </Link>
                                              :  <Link>
                                              <div className="gali_inactive">
                                                    <img src="../images/play_button2.png" />
                                                    <span style={{fontWeight:"500"}}>Play Now</span>

                                              </div>
                                          </Link> }

                                        </div>
                                    </div>
                                </div>

                                        )})}

</div>

                            </div>

                        </div>


                    </div>
                </div>


            </>
        );
    }

}

export default Gali;
